import React from 'react'
import BaseIcon from 'react-icon-base'

const ArrowTop = props => (
  <BaseIcon width="32" height="32" viewBox="0 0 32 32" {...props}>
    <g fill="none" fillRule="evenodd">
      <rect width="32" height="32" fill="#FAFBFC" rx="4" />
      <path fill="#B2BAC5" fillRule="nonzero" d="M16 15.055l-4.5 4.581L10 18.11 16 12l6 6.11-1.5 1.526z" />
    </g>
  </BaseIcon>
)

export default ArrowTop
